<template>
    <div class="hiq-calendar__filters">
        <date-filter></date-filter>
        <category-filter></category-filter>
    </div>
</template>
<script>
import Vue from 'vue';
import DateFilter from './filters/DateFilter.vue';
import CategoryFilter from './filters/CategoryFilter.vue';

export default Vue.extend({
    name: 'filters',
    components: {
        DateFilter,
        CategoryFilter,
    }
})
</script>